"use strict";
exports.__esModule = true;
exports.ThemeProvider = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var CssBaseline_1 = tslib_1.__importDefault(require("@material-ui/core/CssBaseline"));
var react_1 = tslib_1.__importDefault(require("react"));
var ClassPrefixContext_1 = require("../context/ClassPrefixContext");
var DefaultEpilotTheme_1 = require("./DefaultEpilotTheme");
var mapping_1 = require("./mapping");
function ThemeProvider(_a) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? DefaultEpilotTheme_1.DefaultEpilotTheme : _b, _c = _a.classPrefix, classPrefix = _c === void 0 ? '' : _c, isMuiTheme = _a.isMuiTheme;
    var muiTheme = isMuiTheme
        ? theme
        : core_1.createTheme(mapping_1.parseMuiTheme(theme, classPrefix));
    var generateClassName = core_1.createGenerateClassName({
        seed: classPrefix || DefaultEpilotTheme_1.DefaultEpilotTheme.prefix
    });
    return (react_1["default"].createElement(ClassPrefixContext_1.ClassPrefixProvider, { classPrefix: classPrefix },
        react_1["default"].createElement(core_1.StylesProvider, { generateClassName: function (rule, sheet) {
                var className = generateClassName(rule, sheet);
                //Generate random ID for to randomise jss class rule - eg. 7yadq
                var id = (Math.random() + 1).toString(36).substring(7);
                return className.includes('jss') ? className + "--" + id : className;
            } },
            react_1["default"].createElement(core_1.ThemeProvider, { theme: muiTheme },
                react_1["default"].createElement(CssBaseline_1["default"], null),
                children))));
}
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map